import { TextQuestion } from "./text-question";
import type { QuestionTypeRendererProps } from "./shared";

type ShortAnswerQuestionProps = QuestionTypeRendererProps<"short_answer">;

export default function ShortAnswerQuestionType(props: ShortAnswerQuestionProps) {
  return <TextQuestion {...props} kind="short_answer" />;
}
